var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { rules } from 'helpers/Validation';
import { optionsTree } from 'helpers/Utils';
import Stock from 'modules/Stock';
import { Form } from 'components';
import { FieldType } from 'elements';
import { loading } from 'elements/Loading';
var ArticleForm = /** @class */ (function (_super) {
    __extends(ArticleForm, _super);
    function ArticleForm(props) {
        var _this = _super.call(this, props) || this;
        _this.showStock = false;
        // this.props.store!.users.user.profile !== ClientProfile.Professional
        _this.fields = [
            {
                name: 'image',
                type: FieldType.Image
            },
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 3
            },
            {
                name: 'reference',
                type: FieldType.Text,
                rules: rules().string(),
                size: 3
            },
            {
                name: 'barcode',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                size: 4
            },
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required()
            },
            {
                name: 'description',
                type: FieldType.Text,
                rules: rules().string()
            },
            /*{
              name: 'cost',
              type: FieldType.Number,
              rules: rules().number(),
              size: 2
            },
            {
              name: 'margin',
              type: FieldType.Number,
              rules: rules().number(),
              size: 2
            },*/
            {
                name: 'price',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .required(),
                size: 2
            },
            {
                name: 'tax',
                column: 'tax_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                options: _this.props.store.taxes.articleTaxes.map(function (item) {
                    return { name: item.name, value: String(item.id) };
                }),
                size: 2
            },
            {
                name: 'family',
                column: 'family_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer(),
                placeholder: true,
                options: optionsTree(_this.props.store.families.families, 'subfamilies', function (item, level) {
                    return { name: "".concat(level).concat(item.name), value: item.id };
                }),
                size: 5
            }
        ];
        if (_this.showStock)
            _this.fields.push({
                name: 'stockable',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 5
            });
        return _this;
    }
    ArticleForm.prototype.render = function () {
        var article = this.props.article;
        var articles = this.props.store.articles;
        return (React.createElement("div", null,
            React.createElement(Form, { loading: ['post@article/', 'put@article/'], fields: this.fields, values: article, store: articles, stores: this.props.store, calculator: true }),
            this.showStock &&
                article &&
                article.stockable && React.createElement(Stock, { article: article.id })));
    };
    ArticleForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.articles
                    .read(props.match.params.id)
                    .then(function (article) { return ({ article: article }); })
                : undefined,
            props.store.families.read(),
            props.store.taxes.read()
        ]; }),
        observer
    ], ArticleForm);
    return ArticleForm;
}(Component));
export default ArticleForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/containers/ArticleForm.tsx
// module id = 1556
// module chunks = 0